import { i18n } from '@/i18n.js'
import _ from 'lodash'
import productDefault from '@/assets/img/products/product_default.png'

export const Utils = {
  methods: {
    /**
     * @param price
     * @param currency
     */
    formatPrice(price, currency) {
      return new Intl.NumberFormat(i18n.global.locale, { style: 'currency', currency: currency })
        .format(price)
        .replace(/\u00a0/g, ' ')
    },
    /**
     * @param currencyMinorUnit
     */
    currencyMultiplier(currencyMinorUnit) {
      return currencyMinorUnit !== null ? Math.pow(10, currencyMinorUnit) : 100
    },
    deepEquals(x, y) {
      if (x === y) {
        return true // if both x and y are null or undefined and exactly the same
      } else if (!(x instanceof Object) || !(y instanceof Object)) {
        return false // if they are not strictly equal, they both need to be Objects
      } else if (x.constructor !== y.constructor) {
        // they must have the exact same prototype chain, the closest we can do is
        // test their constructor.
        return false
      } else {
        return _.isEqual(x, y)
      }
    },
    /**
     * Return formatted lang
     * @param {string} lang
     * @return {string|null} lang
     */
    formatLang(lang) {
      const formattedLang = lang.split('-')
      return `${formattedLang[0]}_${formattedLang[1].toLowerCase()}`
    },
    isTrue(value) {
      return !![true, 'true', 'True', 1, '1'].includes(value)
    }
  }
}
